import { makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { ApiService } from '~/service/service.api';
import { DashboardService } from '~/service/service.dashboard';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';

@Model()
export class DashboardBrandsModel {
	@observable.ref items: API.AnalyticsTopBrandsItem[] = [];
	readonly async = new Async();

	constructor(
		private api: ApiService,
		private dashboardSvc: DashboardService,
	) {
		makeObservable(this);
	}

	fetchData = (type: API.AnalyticsTopBrandType) => {
		this.async.call(async () => {
			const { data } = await this.api.analyticsTopBrands({ type, days: this.dashboardSvc.period });
			return () => {
				this.items = data.items;
			};
		});
	};
}
